import React, {FC} from 'react';

export const DefaultFooter: FC = () => <></>;
